import { forwardRef, useImperativeHandle } from "react";
import axios from "../../utils/axios";
import Loading from "../Loading";
import DragDrop from "./DragDrop";
import { useMutation } from "react-query";

function Step2({ data, setStamps }, ref) {
  let { file, parts, stamps, docid } = data;

  useImperativeHandle(ref, () => ({
    next: () => addstamp(),
  }));

  const { isLoading, mutateAsync } = useMutation({
    mutationKey: ["add_stamps_to_doc"],
    mutationFn: (data) => axios.post("client/api/doc/stamp/add", data, { showErrorMessage: true }),
  });

  const addstamp = async () => {
    let box = document.querySelector(".document_watermark_container");
    let json = {
      docid: docid,
      stamps: stamps,
      pagewidth: box.clientWidth,
      pageheight: box.clientHeight,
    };
    return await mutateAsync(json);
  };

  return (
    <>
      <Loading loading={isLoading} />
      <div className="step1_container relafull">
        <DragDrop file={file} parts={parts} setStamps={setStamps} stamps={stamps} />
      </div>
    </>
  );
}

export default forwardRef(Step2);
